<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Mortgage Brokers</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Elevate your mortgage brokerage business with LocalScale, your strategic partner in targeted advertising for local lending solutions</p>
                        <p>In the competitive landscape of mortgage lending, establishing a strong local presence is essential for attracting clients and closing deals.</p>
                        <p>With LocalScale, you can enhance your visibility and connect with potential homebuyers in your target neighborhoods and zip codes.</p>
                        <p>Whether you specialize in first-time homebuyer programs, refinancing options, or investment property financing, our precision-targeted ad network enables you to reach individuals actively seeking mortgage solutions.</p>
                        <p>By leveraging LocalScale, you can ensure that your services are top-of-mind when clients are considering their financing options, ultimately driving more leads and closing more loans.</p>
                        <p>Let us help you grow your mortgage brokerage business and become the go-to lender in your community.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-mortgage.png" alt="Mortgage">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been instrumental in helping my mortgage brokerage business thrive. Their targeted advertising solutions have allowed me to reach potential homebuyers in specific neighborhoods and zip codes, resulting in a noticeable increase in client inquiries. Thanks to LocalScale, I've been able to establish myself as a trusted lender in the community and close more loans.”</h3>
                    <p class="testimonial-customer">– Rachel Johnson, Mortgage Broker at Prime Mortgage Solutions</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
